import React, { useState } from "react";

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';

import DateFnsUtils from '@date-io/date-fns';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import { useStyles } from './UserTheme';
import UserCard from "./UserCard";

// user adatok
import UserContext from "../../context/UserContext";

// form validation
import { useForm } from "react-hook-form";

// GET - POST - PUT
import useAxios from "../../request/useAxios";

export default function UserSettingBasis() {
  const [alert, setAlert] = useState(false);
  const classes = useStyles();
  // user adatainak betöltése
  const user = React.useContext(UserContext);
  const { put } = useAxios();

  const { register, handleSubmit } = useForm();

  const handleChangeUserData = (e) => {
    let oldUser = { ...user };
    oldUser.user[e.target.name] = e.target.value;
    user.settings.setUser(oldUser);
  }

  const handleSubmitUserData = (d, e) => {
    const TS = JSON.parse(localStorage.getItem("TS"));
    // const data = JSON.stringify(x);
    put(
      `/salesman/update-profile`,
      user.user,
      {
        headers: {
          'Authorization': `Bearer ${TS.token}`,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      }
    )
      .then((data) => {
        console.log('Put ok')
        setAlert(true);
      })
      .catch((error) => console.log("Could not send user data", error));
  }

  function handleDateChange(date) {
    handleChangeUserData({
      target: {
        name: 'birthDate',
        value: date.toISOString().slice(0, 10)
      }
    });
  };

  const handleClose = (event, reason) => {
    setAlert(false);
  };

  return <Grid container direction="row" className={classes.root}>
    <Grid item className={classes.formContanier}>
      <Snackbar open={alert} autoHideDuration={4000} onClose={handleClose}>
        <Alert className={classes.alert} variant="filled" severity="success">
          A változtatásokat elmentettük.
        </Alert>
      </Snackbar>
      <Typography align="center" variant="h6" gutterBottom>
        Alapadatok
        </Typography>
      <Divider />
      <form className={classes.form}
        onChange={handleChangeUserData}
        onSubmit={handleSubmit(handleSubmitUserData)}
        noValidate
      >
        <Typography variant="h6" className={classes.subtitle}>Név</Typography>
        <div>
          <TextField
            id="user-lastname"
            name="lastname"
            label="Vezetéknév"
            defaultValue={user.user.lastname}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-middleName"
            label="Középső név"
            name="middleName"
            defaultValue={user.user.middleName}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-firstname"
            label="Keresztnév"
            name="firstname"
            defaultValue={user.user.firstname}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="normal"
              fullWidth
              id="date-picker-dialog"
              label="Születésnap"
              format="yyyy/MM/dd"
              variant="inline"
              inputVariant="outlined"
              value={user.user.birthDate}
              onChange={date => handleDateChange(date)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
              inputRef={register()}
            />
          </MuiPickersUtilsProvider>
        </div>
        <div>
          <TextField
            id="user-nationality"
            label="Nemzetiség"
            name="nationality"
            defaultValue={user.user.nationality}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <Typography variant="h6" className={classes.subtitle}>Lakcím</Typography>
        <div>
          <TextField
            id="user-country"
            label="Ország"
            name="country"
            defaultValue={user.user.country}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-county"
            label="Megye"
            name="county"
            defaultValue={user.user.county}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-city"
            label="Város"
            name="city"
            defaultValue={user.user.city}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-postcode"
            label="Irányítószám"
            name="postcode"
            defaultValue={user.user.postcode}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-addres"
            label="Cím"
            name="addres"
            defaultValue={user.user.address}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <div>
          <TextField
            id="user-houseNumber"
            label="Házszám"
            name="houseNumber"
            defaultValue={user.user.houseNumber}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>
        <Typography variant="h6" className={classes.subtitle}>Elérhetőség</Typography>
        <div>
          <TextField
            id="user-phoneNumber"
            label="Telefonszám"
            name="phoneNumber"
            defaultValue={user.user.phoneNumber}
            helperText=""
            variant="outlined"
            size="small"
            type="text"
            fullWidth
            inputRef={register()}
          />
        </div>

        {/* drivingLicense */}

        <div className={classes.button}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
          >
            Beküld
            </Button>
        </div>
      </form>
      {/* </Grid> */}
    </Grid>
    <Grid item xs>
      <Grid container className={classes.grund}>
        <UserCard user={user} />
      </Grid>
    </Grid>
  </Grid >;
}